import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';

import TooltipFooter from './tooltip-footer';
import TooltipHeader from './tooltip-header';
import TooltipTitle from './tooltip-title';

const useStyles = createUseStyles({
  body: {
    background: '#272727',
    borderRadius: 8,
    composes: ['is-relative', 'no-overflow'],
    maxWidth: 400,
    minWidth: 280,
  },
  content: {
    color: '#919191',
    composes: ['mx24', 'my0', 'fs14'],
    lineHeight: 1.3,
  },
});

const RideTooltipComponent = props => {
  const classes = useStyles();
  const { index, size, step, tooltipProps } = props;
  return (
    <div className={classes.body} {...tooltipProps}>
      <TooltipHeader {...props} />
      {step.title && <TooltipTitle isFirst={index === 0} title={step.title} />}
      <div className={classes.content}>{step.content}</div>
      <TooltipFooter total={size} {...props} />
    </div>
  );
};

RideTooltipComponent.propTypes = {
  index: PropTypes.number.isRequired,
  size: PropTypes.number.isRequired,
  step: PropTypes.shape().isRequired,
  tooltipProps: PropTypes.shape().isRequired,
};

RideTooltipComponent.displayName = 'RideTooltipComponent';

export default RideTooltipComponent;
